import './utilities/polyfills'
import './vendors/PleaseUpdateYourBrowser'

import React from 'react'
import ReactDOM from 'react-dom'
import TagManager from 'react-gtm-module'
import { I18nextProvider } from 'react-i18next'
import moment from 'moment'

import config from './config'
import { i18n } from './vendors/i18n'
import { Routes } from './routes'
import { captureAttribution } from './utilities/attribution'

import './vendors/Sentry'
import './vendors/AVAE'
import './vendors/Hotjar'
import './vendors/Zendesk'
import './vendors/UserSnap'

TagManager.initialize(config.gtmArgs)
// Landing URL / referrer must be read before the router rewrites the URL (see InquiryCreationPage)
captureAttribution()

ReactDOM.render(React.createElement(() => {
  moment.locale('fr')
  return (
    <I18nextProvider i18n={i18n}>
      <Routes />
    </I18nextProvider>
  )
}),
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js